(() => {
  if (window.SdmCartBundleLoaded) return;
  window.SdmCartBundleLoaded = true;

  const updateRecommendationNavigation = (track) => {
    if (!track) return;

    const section = track.closest('.sdm-cart-recommendations');
    const previous = section?.querySelector(
      '[data-sdm-recommendations-prev]'
    );
    const next = section?.querySelector(
      '[data-sdm-recommendations-next]'
    );

    if (!previous || !next) return;

    const maximumScroll = Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );

    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maximumScroll - 2;
  };

  const moveRecommendations = (button) => {
    const section = button.closest('.sdm-cart-recommendations');
    const track = section?.querySelector(
      '.sdm-cart-recommendations__track'
    );
    const firstCard = track?.querySelector(
      '.sdm-cart-recommendation'
    );

    if (!track || !firstCard) return;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;

    const direction = button.hasAttribute(
      'data-sdm-recommendations-prev'
    )
      ? -1
      : 1;

    track.scrollBy({
      left:
        direction *
        (firstCard.getBoundingClientRect().width + gap),
      behavior: 'smooth',
    });
  };

  const addRecommendation = async (button) => {
    if (button.disabled) return;

    const drawer = document.querySelector('cart-drawer');
    const variantId = button.dataset.variantId;
    const isPreorder = button.dataset.isPreorder === 'true';
    const preorderShipping = button.dataset.preorderShipping;

    const originalLabel =
      button.querySelector('span')?.textContent || '+ Add';

    if (!drawer || !variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    const label = button.querySelector('span');

    if (label) {
      label.textContent = 'Adding…';
    }

    try {
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', '1');

      /*
       * Add the same preorder line-item property used by the
       * Sol de Madera product-page form.
       */
      if (isPreorder && preorderShipping) {
        formData.append(
          'properties[Pre-order shipping]',
          preorderShipping
        );
      }

      formData.append(
        'sections',
        drawer
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',')
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );

      const response = await fetch(
        window.routes?.cart_add_url || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        }
      );

      const state = await response.json();

      if (!response.ok || state.status) {
        throw new Error(
          state.description ||
            state.message ||
            'This mobile could not be added.'
        );
      }

      drawer.classList.remove('is-empty');
      drawer.setActiveElement(button);
      drawer.renderContents(state);

      requestAnimationFrame(() => {
        const bundle = drawer.querySelector(
          '[data-sdm-cart-bundle]'
        );

        if (bundle) {
          bundle.classList.add('is-celebrating');

          window.setTimeout(() => {
            bundle.classList.remove('is-celebrating');
          }, 900);
        }

        updateRecommendationNavigation(
          drawer.querySelector(
            '.sdm-cart-recommendations__track'
          )
        );
      });
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');

      if (label) {
        label.textContent = 'Try again';
      }

      button.setAttribute(
        'title',
        error.message
      );

      window.setTimeout(() => {
        if (label) {
          label.textContent = originalLabel;
        }

        button.removeAttribute('title');
      }, 2500);
    }
  };

  document.addEventListener('click', (event) => {
    const navigationButton = event.target.closest(
      '[data-sdm-recommendations-prev], ' +
        '[data-sdm-recommendations-next]'
    );

    if (navigationButton) {
      event.preventDefault();
      moveRecommendations(navigationButton);
      return;
    }

    const button = event.target.closest(
      '[data-sdm-bundle-add]'
    );

    if (!button) return;

    event.preventDefault();
    addRecommendation(button);
  });

  document.addEventListener(
    'scroll',
    (event) => {
      if (
        event.target.matches?.(
          '.sdm-cart-recommendations__track'
        )
      ) {
        updateRecommendationNavigation(event.target);
      }
    },
    true
  );

  window.addEventListener('resize', () => {
    document
      .querySelectorAll(
        '.sdm-cart-recommendations__track'
      )
      .forEach(updateRecommendationNavigation);
  });

  let dragStart = null;
  let dragDistance = 0;
  let draggedInner = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      const handle = event.target.closest(
        '[data-sdm-drawer-handle]'
      );

      if (
        !handle ||
        window
          .matchMedia('(min-width: 750px)')
          .matches
      ) {
        return;
      }

      dragStart = event.touches[0].clientY;
      dragDistance = 0;
      draggedInner = handle.closest('.drawer__inner');

      if (draggedInner) {
        draggedInner.style.transition = 'none';
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (
        dragStart === null ||
        !draggedInner
      ) {
        return;
      }

      dragDistance = Math.max(
        0,
        event.touches[0].clientY - dragStart
      );

      draggedInner.style.transform =
        `translateY(${dragDistance}px)`;
    },
    { passive: true }
  );

  document.addEventListener('touchend', () => {
    if (
      dragStart === null ||
      !draggedInner
    ) {
      return;
    }

    const drawer =
      draggedInner.closest('cart-drawer');

    draggedInner.style.transition = '';
    draggedInner.style.transform = '';

    if (dragDistance > 90) {
      drawer?.close();
    }

    dragStart = null;
    dragDistance = 0;
    draggedInner = null;
  });
})();